import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { BaseButton } from './BaseButton';

interface CardHeaderButtonProps {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

export function CardHeaderButton({ icon, label, onClick, children }: CardHeaderButtonProps) {
    return (
        <Button onClick={onClick}>
            {icon}
            {label}
            {children}
        </Button>
    );
}

const Button = styled(BaseButton)({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    border: `1px solid ${Colors.border}`,
    borderRadius: 20,
    fontSize: 14,
    color: Colors.textSecondary,
    padding: '6px 16px',
    whiteSpace: 'nowrap',
    '&:hover': {
        color: Colors.primary,
        backgroundColor: Colors.surface,
        borderColor: Colors.surface,
    },
});
